export default "__VITE_PUBLIC_ASSET__c2780756__"